import React, { useState } from "react";
import Quality_Plan_Form from "./quality_Plan_Form/Quality_Plan_Form";
import Common_Back_Btn from "../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Quality_Plan_table from "./quality_Plan_table/Quality_Plan_table";

function Quality_Plan() {
  const [showTable, setShowTable] = useState(false);

  return (
    <>
      <section className="Sample_Report">
        <div className="back_div">
          <Common_Back_Btn backText="Quality Control Plan" />
        </div>
        <div className="imperiality_Form_div">
          <Quality_Plan_Form onProceed={() => setShowTable(true)} />
        </div>

        {showTable && (
          <div className="imperiality_table_div">
            <Quality_Plan_table />
          </div>
        )}
      </section>
    </>
  );
}

export default Quality_Plan;
